import React, { FC } from 'react';
import { FieldEditFrameComponent } from '../../../@shared/editFrame';
import Icon from '../../../@shared/icon';
import CustomExternalAnchor from '../../../@shared/customExternalAnchor';
import { iconSize } from '../../../../constants/icon.constants';
import fields from '../../../../constants/fields.const';
import { SocialMediaModel } from './models/index.model';
import { TSocialMediaProps } from './types/index.types';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import { googleSocialProfileClickEvent } from '../../../../utils/analytics';
import useBrandName from '../../../../hooks/useBrand.effect';
import { BRANDS } from '../../../../constants/brandNames.contants';
import './styles.scss';

const SocialMedia: FC<TSocialMediaProps> = (props: TSocialMediaProps) => {
  const model = new SocialMediaModel(props);
  const isEEactive = props?.sitecoreContext?.pageEditing;
  const isDesktop = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);
  const brandName = useBrandName();
  const iconColor = brandName === BRANDS.NEW_HOLLAND ? 'black' : 'primary';

  const getIconSize = () => {
    if (brandName === BRANDS.NEW_HOLLAND) {
      return isDesktop ? iconSize.dsk : iconSize.mbl;
    }

    return isDesktop ? iconSize.md : iconSize.dsk;
  };

  return (
    <>
      {model?.socialLinks?.length > 0 && (
        <div className="case-ce-social-media">
          <div className="case-ce-social-media__links-wrapper">
            {model?.socialLinks?.map((item) => {
              const canShowLinkInNormalMode = !!(item?.fields?.link?.value?.href && item?.fields?.icon?.fields?.iconUrl?.value);
              return (
                (isEEactive || canShowLinkInNormalMode) && (
                  <div className="case-ce-social-media__social-icon-link-wrapper" key={item?.id}>
                    {isEEactive ? (
                      <>
                        <CustomExternalAnchor
                          field={item?.fields?.link}
                          key={item?.id}
                          className={'social-media-section__social-icon-link'}
                          target="_blank"
                        />
                        <FieldEditFrameComponent itemId={item.id} fields={[fields.icon]} sitecoreContext={props?.sitecoreContext}>
                          <Icon iconField={item?.fields?.icon} size={getIconSize()} color={iconColor} />
                        </FieldEditFrameComponent>
                      </>
                    ) : canShowLinkInNormalMode && (
                      <CustomExternalAnchor
                        field={item?.fields?.link}
                        key={item?.id}
                        className={'social-media-section__social-icon-link'}
                        target="_blank"
                        onClick={() =>
                          googleSocialProfileClickEvent(item?.fields?.link?.value?.href, item?.fields?.link?.value?.text || item?.displayName)
                        }
                      >
                        <Icon
                          iconField={item?.fields?.icon}
                          extraClassName="case-ce-social-media__social-icon"
                          size={getIconSize()}
                          color={iconColor}
                        />
                      </CustomExternalAnchor>
                    )}
                  </div>
                )
              )
            })}
            <div className="case-ce-social-media__highlight-bar" />
          </div>
        </div>
      )}
    </>
  );
};

export default SocialMedia;
